export const PATH_FLEETS = "/fleets";
export const PATH_FLEETS_UID = `${PATH_FLEETS}/:uid`;
